import { render } from "./ContactHeader.vue?vue&type=template&id=4a388e2a&scoped=true"
import script from "./ContactHeader.vue?vue&type=script&lang=js"
export * from "./ContactHeader.vue?vue&type=script&lang=js"

import "./ContactHeader.vue?vue&type=style&index=0&id=4a388e2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a388e2a"]])

export default __exports__